import { Fragment } from 'react'
import ReactTooltip from 'react-tooltip'
import { useIntl, defineMessages } from 'react-intl'

import cx from 'classnames'
import styles from '../dive-center/AdventureCardDsl.module.scss'

const messages = defineMessages({
  instantConfirmation: {
    id: 'instantConfirmation',
    defaultMessage: 'Instant confirmation',
  },
})

function InstantConfirmation({ isDsl }) {
  const intl = useIntl()
  return (
    <Fragment>
      <i
        className={cx('font-icons icon-lightning', {
          [styles.instantConfirmation]: isDsl,
        })}
        data-tip={intl.formatMessage(messages.instantConfirmation)}
      />
      <ReactTooltip effect='solid' />
    </Fragment>
  )
}
export default InstantConfirmation
